import MobileShell from '@/components/MobileShell';
import { PRIVACY_PDF_PAGES } from '@/lib/legalContent/privacyPdfContent';

export default function Privacy() {
  return (
    <MobileShell title="Privacy Policy">
      <div className="bg-slate-100 px-3 py-4 sm:px-5 sm:py-6">
        <div className="mx-auto max-w-4xl space-y-5">
          {PRIVACY_PDF_PAGES.map((page, index) => (
            <article
              key={index}
              data-testid={index === 0 ? 'privacy-doc-first' : undefined}
              className="bg-white border border-slate-200 shadow-sm px-5 py-6 sm:px-10 sm:py-9"
            >
              <pre
                className="m-0 whitespace-pre-wrap break-words text-[13px] leading-6 text-slate-900 sm:text-sm sm:leading-7"
                style={{ fontFamily: 'Arial, sans-serif' }}
              >
                {page}
              </pre>
            </article>
          ))}
        </div>
      </div>
    </MobileShell>
  );
}
